// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"e6398029","145":"a23ffa44","150":"621c57aa","248":"70697a0b","453":"b466121f","918":"442f07b3"}[chunkId] + ".chunk.js";
};